import moment from 'moment';
// import { useNavigation } from '@react-navigation/native';
// import { useDispatch } from 'react-redux';
// import { resetUserState } from '../store/authSlice';
export const containsAtleastOneUpperCase = (val: string) =>
  /(?=.*?[A-Z])/.test(val);

export const containsAtleastOneLowerCase = (val: string) =>
  val ? /(?=.*?[a-z])/.test(val) : false;

export const containsAtleastOneNumber = (val: string) =>
  /(?=.*[0-9])/.test(val);

export const containsAtLeastOneSpecialChar = (val: string) =>
  /(?=.*[$&+,:;=?@#|'<>.^*_()%!-])/.test(val);

export const MINIMUM_PASSWORD_LENGTH = 6;
export const verificationLength = 11;
export const tinLength = {min: 8, max: 10};

export const isEven = (number: number) => (number ? number % 2 === 0 : false);

export const isOdd = (number: number) => number % 2 !== 0;

export const formatToNaira = (
  amount: number | undefined,
  currency = '₦',
): string => {
  if (!amount || isNaN(amount)) {
    return `${currency}0.00`;
  }
  const formattedAmount = amount?.toFixed(2);
  return `${currency}${formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

export const formatToNairaTo = (
  amount: number | undefined,
  currency = '₦',
): string => {
  if (!amount || isNaN(amount)) {
    return `${currency}0.00`;
  }
  const formattedAmount = amount?.toFixed(2);
  return `${currency}${formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

export const formatToNairaDecimal = (
  amount: number | undefined,
  currency = '₦',
  digits = 1,
): string => {
  if (amount === undefined || isNaN(amount)) {
    return `${currency}`;
  }

  const units = [
    {value: 1_000_000_000, suffix: 'b'},
    {value: 1_000_000, suffix: 'm'},
    {value: 1_000, suffix: 'k'},
  ];

  for (const unit of units) {
    if (amount >= unit.value) {
      const shortened = (amount / unit.value).toFixed(digits);
      return `${currency}${shortened}${unit.suffix}`;
    }
  }

  // For small numbers, show normal format with commas
  return `${currency}${amount.toLocaleString()}`;
};

export const fixedAmount = [
  {label: '₦5,0000', value: 5000},
  {label: '₦10,0000', value: 10000},
  {label: '₦50,0000', value: 50000},
  {label: '₦100,0000', value: 100000},
];

export const frequency = [
  {label: 'One-Off', value: 'one-off'},
  {label: 'Weekly', value: 'weekly'},
  {label: 'Monthly', value: 'monthly'},
  {label: 'Quaterly', value: 'quaterly'},
  {label: 'Annually', value: 'annually'},
];

export const formatCurrency = (
  amount: number | undefined,
  currency: '₦' | '$' = '₦',
): string => {
  if (!amount || isNaN(amount)) {
    return currency === '₦' ? `${currency}0.00` : `${currency}0`;
  }

  const formattedAmount =
    currency === '₦'
      ? amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : Math.round(amount)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return `${currency}${formattedAmount}`;
};

export const formatTenorToYears = (runningTenor: number) => {
  const years = Math.floor(runningTenor / 365); // Calculate full years
  const days = runningTenor % 365; // Calculate remaining days after full years

  let formattedTenor = '';
  if (years > 0) {
    formattedTenor += `${years} year${years > 1 ? 's' : ''}`;
  }
  if (days > 0) {
    if (years > 0) {
      formattedTenor += `, `;
    }
    formattedTenor += `${days} day${days > 1 ? 's' : ''}`;
  }

  return formattedTenor || '0 days';
};

export function convertToDays(
  loanTenor: number,
  paymentStructure: 'Weekly' | 'Monthly' | 'Daily',
): number {
  switch (paymentStructure) {
    case 'Weekly':
      return loanTenor * 7;
    case 'Monthly':
      return loanTenor * 30;
    case 'Daily':
      return loanTenor;
    default:
      throw new Error('Invalid payment structure');
  }
}

export const calculateMaturityDate = (
  createdAt: string,
  loanTenorInDays: number,
) => {
  // Parse the createdAt date
  const createdDate = moment(createdAt);

  // Add loanTenorInDays to the createdDate
  const maturityDate = createdDate.add(loanTenorInDays, 'days');

  // Format the maturity date
  return maturityDate.format('Do MMMM, YYYY');
};

export const calculateMaturityDateForLoan = (loanTenorInDays: number) => {
  const maturityDate = moment().add(loanTenorInDays, 'days');
  // Format the maturity date
  return formatDate(maturityDate.toISOString());
};

export const formatDate = (date?: string): string => {
  return moment(date).format('Do MMMM, YYYY');
};
export const formatSecondDate = (date?: string): string => {
  return moment(date).format('D MMMM • hh:mm a');
};
export const formatThirdDate = (date?: string): string => {
  return moment(date).format('MMMM D, YYYY');
};
export const formatTime = (date?: string): string => {
  return moment(date).format('hh:mm a');
};

export const formatMonth = (date?: string): string => {
  return moment(date).format('mm');
};

export const formatPercentage = (value: number): string => {
  if (isNaN(value)) {
    return '0%';
  }

  const percentageValue = Math.round(value * 1);

  return `${percentageValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}%`;
};



// export const logOut = async () => {
//   const dispatch = useDispatch();
//   const navigation = useNavigation() as any;
//   try {
//     await AsyncStorage.removeItem('user');
//     await AsyncStorage.removeItem('token');
//     dispatch(resetUserState());
//     navigation.navigate('Login');
//   } catch (e) {
//     console.log('Error removing data', e);
//   }
// };

export const truncateText = (text: string, maxLength: number = 20): string => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
};

export const getKeyByValue = (
  enumObj: any,
  value: number,
): string | undefined => {
  return Object.keys(enumObj).find(key => enumObj[key] === value);
};
